import type { BackendSport, TransformedSport } from './types';

export const transformSport = (entry: BackendSport): TransformedSport => ({
  id: entry.id,
  name: entry.name,
  priority: entry.priority,
});
